<template>
  <div class="bh-navbar">
    <!-- username menu, cart, search -->
    <div class="top-navbar">
      <div class="container px-0">
        <b-navbar-nav
          class="w-100 px-2 px-sm-0 d-flex flex-row justify-content-end align-items-center"
        >
          <b-nav-item link-classes="p-2">
            <div class="d-flex justify-content-center align-items-center">
              <b-icon
                icon="person"
                style="color: #ffd400"
                class="mr-2"
              ></b-icon>
              <div v-if="isLoggedin">
                <b-dropdown
                  size="sm"
                  class="user-menu"
                  variant="link"
                  no-caret
                  boundary="viewport"
                >
                  <template #button-content>
                    <div class="xd-text w-regular s-14 text-white">
                      {{ displayUser }}
                    </div>
                  </template>
                  <b-dropdown-item
                    to="/Account/PurchaseHistory"
                    exact-active-class="font-weight-bold"
                    >ประวัติสั่งซื้อ</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="!this.disableEbook"
                    to="/Account/Account-MyEBook"
                    exact-active-class="font-weight-bold"
                    >E-Book ของฉัน</b-dropdown-item
                  >
                  <b-dropdown-item
                    to="/Account/MyFavorite"
                    exact-active-class="font-weight-bold"
                    >รายการโปรด</b-dropdown-item
                  >
                  <b-dropdown-item
                    to="/Account/Address"
                    exact-active-class="font-weight-bold"
                    >ที่อยู่จัดส่ง</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="this.enableReceipt"
                    to="/Account/Receipt"
                    exact-active-class="font-weight-bold"
                    >ดาวน์โหลดใบเสร็จ</b-dropdown-item
                  >
                  <b-dropdown-item
                    to="/Account/ProductReturn"
                    exact-active-class="font-weight-bold"
                    >รายการคืนสินค้า</b-dropdown-item
                  >
                  <b-dropdown-item
                    to="/Account/ProfileSetting"
                    exact-active-class="font-weight-bold"
                    >แก้ไขข้อมูลของฉัน</b-dropdown-item
                  >
                  <b-dropdown-item
                    to="/Account/ChangePassword"
                    exact-active-class="font-weight-bold"
                    >ตั้งค่ารหัสผ่าน</b-dropdown-item
                  >
                  <b-dropdown-item @click="onLogout"
                    ><div style="color: red">ออกจากระบบ</div></b-dropdown-item
                  >
                </b-dropdown>
              </div>
              <div
                v-if="!isLoggedin"
                @click="onLogin"
                class="xd-text w-regular s-14"
              >
                เข้าสู่ระบบ/ลงทะเบียน
              </div>
            </div>
          </b-nav-item>
          <b-nav-item
            href="#"
            to="/cart"
            link-classes="cart-btn p-2"
            exact-active-class="active"
          >
            <div class="d-flex justify-content-center align-items-center">
              <b-icon
                icon="basket"
                style="color: #ffd400"
                class="mr-2"
              ></b-icon>
              <span class="xd-text w-regular s-14"
                >{{ this.$store.getters.gettotalBook }} เล่ม</span
              >
            </div>
          </b-nav-item>
          <b-nav-item
            href="#"
            style="z-index: 100; background-color: rgb(2, 54, 76)"
            id="customautocomplete"
          >
            <BookAutoComplete v-bind:display="true"></BookAutoComplete>
          </b-nav-item>
        </b-navbar-nav>

        <div
          class="w-100 d-flex Aend align-items-center autocomplete-moblie"
          style="background-color: rgb(2, 54, 76)"
        >
          <BookAutoCompleteForMobile
            v-bind:display="true"
          ></BookAutoCompleteForMobile>
        </div>
      </div>
    </div>
    <!-- end username menu, cart, search -->

    <!-- app logo, and mobile menu -->
    <div class="middle-navbar">
      <router-link to="/">
        <div class="app-logo-container">
          <img src="../assets/LogoWeb.png" height="100%" />
        </div>
      </router-link>
      <div class="navbar-menu-container">
        <div class="navber-open-btn" @click="openNavigation">
          <img src="../assets/menu.svg" height="24" width="24" />
        </div>
      </div>
    </div>
    <!-- end logo, and mobile menu -->

    <!-- app menu -->
    <div class="bottom-navbar">
      <div class="navbar-collapse" :class="{ active: showNavbar }">
        <ul class="navbar-nav">
          <router-link class="nav-item" to="/"
            ><span @click="closeNavigation">หน้าหลัก</span></router-link
          >

          <router-link class="nav-item" to="/bookstore"
            ><span @click="closeNavigation">คลังหนังสือ</span></router-link
          >

          <router-link class="nav-item" to="/about"
            ><span @click="closeNavigation">เกี่ยวกับเรา</span></router-link
          >

          <router-link class="nav-item" to="/howtoroder"
            ><span @click="closeNavigation">วิธีการสั่งซื้อ</span></router-link
          >

          <router-link class="nav-item hightlight" to="/Subscription" v-if="!this.disableSubscription"
            ><span @click="closeNavigation"
              >เข้าสู่ระบบสมาชิก</span
            ></router-link
          >

          <a href="#" class="navber-close-btn" @click="closeNavigation">
            <img src="../assets/close.svg" height="48" width="48" />
          </a>
        </ul>
      </div>
    </div>
    <!-- end app menu -->
  </div>
</template>

<style scoped lang="scss">
$layout-breakpoint-mobile: 960px;

.bh-navbar {
  width: 100%;

  .top-navbar {
    background-color: #02364C;
    color: #fff;

    a {
      color: #fff;
      text-decoration: none !important;

      &:hover,
      &:focus,
      &:active {
        text-decoration: none !important;
      }
    }

    .cart-btn {
      &.active {
        border-bottom: 4px solid #fff;
      }
    }
  }

  .middle-navbar {
    background-color: #ffd400;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 10px 13px;

    @media screen and (max-width: $layout-breakpoint-mobile) {
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }

    .app-logo-container {
      height: 100px;
      margin-bottom: 27px;

      @media screen and (max-width: $layout-breakpoint-mobile) {
        height: 50px;
        margin-bottom: 0;
      }
    }

    .navbar-menu-container {
      display: none;

      @media screen and (max-width: $layout-breakpoint-mobile) {
        display: block;
        margin: 10px 0;
      }

      .navber-open-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        color: #fff;
        border: 2px solid #fff;
        border-radius: 50%;
        font-size: 16px;
      }
    }
  }

  .bottom-navbar {
    width: 100%;
    background: #ffd400;

    .navbar-nav {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      .nav-item {
        padding: 8px 16px;
        color: #404040;

        &.router-link-exact-active {
          border-bottom: 4px solid #fff;
          color: #fff;
        }

        &.hightlight {
          color: #db3a34;

          &.router-link-exact-active {
            border-bottom: 4px solid #fff;
            color: #fff;
          }
        }

        &:hover {
          text-decoration: none;
        }
      }
    }

    .navbar-collapse {
      transition: 0.5s;

      &.active {
        width: 100%;
        height: 100vh; // <--- 100vh instead of 100%
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        background: #ffd400;

        .navbar-nav {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 100%;

          .nav-item {
            font-size: 24px;
            padding-left: 0;
            padding-right: 0;
            margin: 0.5rem 0;
            font-weight: 500;

            &.hightlight {
              color: #404040;
            }
          }
        }

        .navber-close-btn {
          display: block;
          position: fixed;
          bottom: 8vh;
        }
      }

      @media screen and (max-width: $layout-breakpoint-mobile) {
        .navbar-nav {
          display: none;
        }
      }

      .navber-close-btn {
        display: none;
      }
    }
  }
}
</style>

<script>
import BookAutoComplete from "@/components/BookAutoComplete";
import BookAutoCompleteForMobile from "@/components/BookAutoCompleteForMobile";
import { ENABLE_RECEIPT } from "../libs/config";
import { DISABLE_EBOOK } from "../libs/config";
import { DISABLE_SUBSCRIPTION } from "../libs/config";
export default {
  components: {
    BookAutoComplete,
    BookAutoCompleteForMobile
  },
  props: {
    isLoggedin: {
      type: Boolean,
      required: true,
      default: false
    },
    displayUser: {
      type: String,
      required: true,
      default: ""
    }
  },
  data() {
    return {
      enableReceipt: ENABLE_RECEIPT,
      disableEbook: DISABLE_EBOOK,
      disableSubscription: DISABLE_SUBSCRIPTION,
      showNavbar: false
    };
  },
  methods: {
    openNavigation() {
      this.showNavbar = true;
    },
    closeNavigation() {
      this.showNavbar = false;
    },
    onLogin() {
      this.$emit("login");
    },
    onLogout() {
      this.$emit("logout");
    }
  }
};
</script>

